import styled from"@emotion/styled";import{Button,InputNumber,AutoComplete,mediaQuery}from"@wp/src/components/common";import{Form,FormItem}from"@wp/src/components/common/form";export const FormContainer=styled.div`
  width: 100%;
`;export const SubmitButton=styled(Button)``;export const StyledForm=styled(Form)`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: center;
  align-items: stretch;
  gap: 16px;
`;export const InvestmentForm=styled(Form)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: center;
  align-items: stretch;
  column-gap: 16px;
  row-gap: 8px;

  ${mediaQuery({justifyContent:["flex-start"],flexWrap:["wrap","wrap","wrap","nowrap","nowrap"],display:["block","block","block","flex","flex"]})}
  .ant-spin-nested-loading {
    flex: ${props=>props.includeSharesInputCount?"1 1 70%":"1"};
  }
  .ant-spin-container {
    margin-top: ${props=>props.compactMobileView?"20px":""};
    column-gap: 16px;
    row-gap: 8px;
    display: flex;
    ${mediaQuery({flexWrap:["wrap","wrap","nowrap","nowrap","nowrap"]})}
  }
`;export const StyledFormItem=styled(FormItem)`
  margin-bottom: 0 !important;
  .ant-col {
    position: unset;
    min-height: unset;
  }
  .ant-form-item-row {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }

  .ant-form-item-label {
    & > label {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;

      color: ${props=>props.theme.colors.neutral800};
    }

    & > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
      color: ${props=>props.theme.colors.neutral800} !important;
    }

    padding: 0 !important;
  }

  .ant-form-item-control {
    width: 100%;
  }
`;export const InvestmentFormItem=styled(StyledFormItem)`
  flex-grow: 1;

  .ant-form-item-control-input-content {
    height: 40px;
  }
`;export const AmountFormItem=styled(StyledFormItem)`
  min-width: 140px;

  flex: 1;
`;export const SubmitFormItem=styled(StyledFormItem)`
  flex: 1;
  .ant-form-item-control {
    justify-content: center;
    align-items: center;

    ${mediaQuery({paddingTop:["12px","32px"]})}
  }
`;export const AmountInput=styled(InputNumber)``;export const TickerAutoSuggestionInput=styled(AutoComplete)``;